/**
 * Sanitization HTML (liste blanche) pour v-html — recommandations IA, etc.
 */
import DOMPurify from 'dompurify';

const DEFAULT_CONFIG = {
  ALLOWED_TAGS: [
    'p', 'br', 'strong', 'em', 'b', 'i', 'u', 'ul', 'ol', 'li',
    'h2', 'h3', 'h4', 'table', 'thead', 'tbody', 'tr', 'th', 'td',
    'span', 'div', 'blockquote',
  ],
  ALLOWED_ATTR: ['class', 'colspan', 'rowspan'],
  FORBID_TAGS: ['script', 'style', 'iframe', 'object', 'embed', 'link', 'meta', 'form', 'input'],
  FORBID_ATTR: ['style', 'onerror', 'onload', 'onclick', 'onmouseover', 'href', 'src'],
  ALLOW_DATA_ATTR: false,
  ADD_URI_SAFE_ATTR: [],
};

export function sanitizeHtml(dirty) {
  const raw = String(dirty ?? '');
  if (!raw.trim()) return '';
  return DOMPurify.sanitize(raw, DEFAULT_CONFIG);
}
